import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useContext } from 'react';
import Chatbot from '../chatbot';
import ModalModule from '../modal';
import UI from '../ui';
import Utils from '../utils';

const { InlineMessage } = UI;
const { Analytics } = Utils;

const { ChatbotTriggers, launchChatbot } = Chatbot;
const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

type FundingRestrictedModalProps = {
	modalId: number;
};

export const FundingRestrictedModal = ({
	modalId,
}: FundingRestrictedModalProps) => {
	const { closeModal, showModal } = useContext(ModalContext);
	const flags = useFlags();

	const startChat = () => {
		closeModal(modalId, ModalButtonActionType.Ok);

		Analytics.trackEvent(
			'live-chat-transfer',
			{
				limit_remaining: null,
			},
			Analytics.agent.segment
		);

		launchChatbot({ flags, showModal, trigger: ChatbotTriggers.AddFunds });
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Start chat',
		onClick: startChat,
		dataqa: 'funding-restricted-start-chat-button',
	};

	return (
		<Modal
			modalId={modalId}
			header="Funding Restricted"
			primaryButton={primaryButton}
			size="small"
		>
			<InlineMessage
				type="error"
				className="funding-restriction-message"
				text={
					<>
						<span>
							Funding is restricted for this account. To add more funds to your
							account balance, you must verify your identity.
						</span>
						<span>
							Chat with a live agent or call 1 (844) 522-7314 (available
							Monday–Friday 8am - 8pm CT).
						</span>
					</>
				}
				dataqa="funding-restricted-inline-message"
			/>
		</Modal>
	);
};
